import { useState } from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../contexts/AuthContext';
import ConfirmationDialog from '../Dialog/Confirmation';
import { removeAccount as removeStudentAccount } from '../../services/Student';
import { removeAccount as removeMasterAccount } from '../../services/Master';

const AccountButton = styled(Button)`
    text-transform: none;
`;

const MenuText = styled.div`
    padding: 0px 16px;
    font-style: italic;
    font-size: 90%;
    &:last-of-type {
        margin-bottom: 4px;
    }
`;

export default function AccountMenu({ label = 'account' }) {
    const { auth } = useAuthContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const executeRemoveAccount = () => {
        if (auth.permissionLevel > 1) {
            //master
            removeMasterAccount(auth.token)
                .then(() => {
                    enqueueSnackbar(t('confirmation.removeMasterAccount'), {
                        variant: 'success',
                    });
                })
                .catch((err) => {
                    enqueueSnackbar(
                        `${t('error.removeAccount')} (${err.message})`,
                        {
                            variant: 'error',
                        }
                    );
                });
        } else {
            //student
            removeStudentAccount(auth.token)
                .then(() => {
                    enqueueSnackbar(t('confirmation.removeStudentAccount'), {
                        variant: 'success',
                    });
                })
                .catch((err) => {
                    enqueueSnackbar(
                        `${t('error.removeAccount')} (${err.message})`,
                        {
                            variant: 'error',
                        }
                    );
                });
        }
        setShowConfirmation(false);
        handleClose();
    };
    const removeAccountClick = () => {
        setShowConfirmation(true);
    };

    let removeMsg = t(
        auth.permissionLevel > 1
            ? 'dialog.removeMasterAccountText'
            : 'dialog.removeUserAccountText',
        { returnObjects: true }
    );
    if (Array.isArray(removeMsg)) {
        removeMsg = removeMsg.map((line, i) => <p key={i}>{line}</p>);
    }

    if (!label || label === '') {
        return null;
    }
    return (
        <div>
            <AccountButton
                id="account-menu-button"
                aria-controls="account-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={<ExpandMoreIcon />}
            >
                {label}
            </AccountButton>
            <Menu
                id="account-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'account-menu-button',
                }}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuText>name: {auth.username}</MenuText>
                <MenuText>email: {auth.useremail}</MenuText>
                <MenuItem onClick={removeAccountClick}>
                    {t('menu.removeAccount')}
                </MenuItem>
            </Menu>

            <ConfirmationDialog
                open={showConfirmation}
                title="Waarschuwing"
                onCancel={() => {
                    setShowConfirmation(false);
                    handleClose();
                }}
                onAccept={executeRemoveAccount}
            >
                {removeMsg}
            </ConfirmationDialog>
        </div>
    );
}
